// extracted by mini-css-extract-plugin
export default {"component":"CommonOverlay_component__mz6Pe","container":"CommonOverlay_container__IBIQd"};